module.exports = __webpack_public_path__ + "img/catagory2.836523f4.png";